import axios from "axios";
import { appConstants } from "./appConstants";
import { showResMsg } from "./generic";
export async function rctiAttachmentUrl(documentID) {
  const response = await axios.get(
    `${appConstants.baseURL}invoice/rctiAttachment/${encodeURIComponent(
      documentID
    )}`,
    {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` },
      responseType: "blob",
      timeout: 30000,
    }
  );
  return URL.createObjectURL(response.data);
}
export async function downloadRctiAttachment(document) {
  try {
    const url = await rctiAttachmentUrl(document._id);
    const link = window.document.createElement("a");
    link.href = url;
    link.download = String(document.documentName || "attachment").replace(
      /[\\/:*?"<>|]/g,
      "_"
    );
    window.document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 30000);
  } catch {
    showResMsg(
      "The attachment could not be downloaded. Sign in again or retry.",
      3000,
      false
    );
  }
}
